if ( window.wp && window.wp.ajax ) {

    const { registerBlockType } = window.wp.blocks;
    
    const {
        InspectorControls,
        InspectorAdvancedControls,
        RichText,
    } = window.wp.editor;
    
    const { 
        TextControl,
        PanelBody
    } = window.wp.components;

    const { Fragment } = window.wp.element;

    registerBlockType('custom-gutenberg/section-title-cta', {
        // built-in attributes
        title: 'Section Title Cta',
        description: 'Section Title With Button',
        icon: 'slides',
        category: 'custom-components',
        example: {},

        // custom attributes
        attributes: {
            anchor: {
                type: 'string',
                default: ''
            },
            title: {
                type: 'string',
                default: 'Title',
            },
            description: {
                type: 'string',
                default: 'Description',
            },
            cta: {
                type: 'string', 
                default: 'Otkrijte više'
            },
            link: {
                type: 'string', 
                default: ''
            }
        },

        // built-in functions
        edit({ attributes, setAttributes }) {

            const {
                anchor,
                title,
                description,
                cta,
                link
            } = attributes;

            // custom functions
            function onLinkChange (link) {
                setAttributes({link: link});
            };

            function onTextChange(text) {
                setAttributes({text: text});
            }

            function onTitleChange(title) {
                setAttributes({title: title});
            }

            function onDescriptionChange(description) {
                setAttributes({description: description});
            }

            function onCtaChange(cta) {
                setAttributes({cta: cta});
            }

            return ([
                <Fragment>
                    <InspectorControls style={ { marginBottom: '40px' } }>
                        <PanelBody title={ 'Settings' }>
                            <p><strong>Title</strong></p>
                            <TextControl value={ title } onChange={ onTitleChange }></TextControl>
                            <br />

                            <p><strong>Description</strong></p>
                            <TextControl value={ description } onChange={ onDescriptionChange }></TextControl>
                            <br />
                            <p><strong>Enter url: (ex: /putovanja)</strong></p>
                            <TextControl value={ link } onChange={ onLinkChange }></TextControl>
                            <br />
                            <p><strong>Button text</strong></p>
                            <TextControl value={ cta } onChange={ onCtaChange }></TextControl>
                        </PanelBody>
                    </InspectorControls>
                    <InspectorAdvancedControls>
                        <TextControl
                            __nextHasNoMarginBottom
                            __next40pxDefaultSize
                            label="HTML anchor"
                            value={ anchor }
                            onChange={ ( anchor ) => {
                                setAttributes( {
                                    anchor: anchor,
                                } );
                            } }
                            />
                    </InspectorAdvancedControls>
                </Fragment>,
                <div id={ anchor } className="section-title-cta">
                        <RichText 
                            key="editable" 
                            tagName="h2"
                            className="title"
                            placeholder="TITLE" 
                            value={ title }
                            onChange={ onTitleChange } />
                    <div className="section-content">
                        <RichText 
                            key="editable" 
                            tagName="p"
                            className="description text-dark"
                            value={ description }
                            onChange={ onDescriptionChange } />
                        <div class="cta-btn" style= {{ 
                            background: '#B39A84',
                            padding: '10px 30px',
                            color: 'white'
                            }}>
                            <RichText 
                                key="editable" 
                                tagName="div"
                                className="text text-white btn btn-waning"
                                value={ cta }
                                onChange={ onCtaChange } />
                        </div>
                    </div>
                </div>
            ]
            );
        },

        save({ attributes }) {
            const {
                anchor,
                title,
                description,
                cta,
                link
            } = attributes;
            return (
                <div id={ anchor } className="section-title-cta">
                    <h2> { title } </h2>
                    <div className="section-content">
                        <p className="description"> { description } </p>
                        <a href={ link } class="cta-btn btn btn-warning" tabindex="-1" role="button">
                            { cta }
                        </a>
                    </div> 
                </div>
            );
        },
    });
}